<button [type]="type" (click)="onClick()" mat-raised-button [color]="color" [disabled]="disabled"
    [title]="hintTranslateKey || titleTranslateKey | translate">
    <span *ngIf="iconClass" class="fal fa-fw fa-material" [ngClass]="iconClass">&nbsp;</span><span
        class="d-none d-md-inline">{{titleTranslateKey | translate : titleArgument}}</span>
    <ng-content></ng-content>
</button>